import caller from "../../helpers/caller";

/** Questionários do cliente, do mais recente para o mais antigo. */
export default async function getCustomerQuestionnaires(api, customerId) {
  return await caller(api.get, "/customer_questionnaire/get_by_customer", {customerId});
}
